import React, { useEffect, useCallback, useState } from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Routes, Route, useNavigate } from 'react-router-dom';
import store from './store';

import Navbar from './Components/Navbar/Navbar';
import Dashboard from './Components/Dashboard/Dashboard';
import RequestedProperties from './Components/RequestedProperties/RequestedProperties';
import Login from './Components/Login/Login';
import CivilProfile from './Components/EditProfile/ApplicationForm';
import PostSubmissionStepper from './Components/EditProfile/PostSubmissionStepper';
import ProfileEdit from './Components/ProfileEdit/ProfileEdit';
import PropertiesService from './Services/PropertiesService';
import CivilStatusModal from './Components/CivilStatusModal/CivilStatusModal';
import TermsAndConditions from './Components/EditProfile/TermsAndConditions';
import { GoogleOAuthProvider } from '@react-oauth/google';

const AppContent = () => {
  const [engineerStatus, setEngineerStatus] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate()
  const getSingleEngineer = useCallback(async () => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (!userDetails?.civilEng_id) return;

    const obj = { userId: userDetails.civilEng_id };
    try {
      const response = await PropertiesService.getCivilEngineer(obj);
      const status = response?.data?.data?.activeStatus;

      if (status && status !== 'Active' && status !== 'On Leave') {
        setEngineerStatus(status);
        setIsModalOpen(true);
      } else {
        setEngineerStatus('')
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error('Error fetching engineer data:', error);
    }
  }, []);
  const closeModel = () => {
    setIsModalOpen(false)
    navigate('/')
    localStorage.clear()
  }

  useEffect(() => {
    getSingleEngineer();
    const handleFocus = () => getSingleEngineer();
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [getSingleEngineer]);

  return (
    <>
      <CivilStatusModal
        isOpen={isModalOpen}
        onClose={closeModel}
        status={engineerStatus}
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="navbar" element={<Navbar userStatus22={engineerStatus} />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile-edit" element={<CivilProfile />} />
          <Route path="post-submission" element={<PostSubmissionStepper />} />
          <Route path="reqProperty" element={<RequestedProperties />} />
          <Route path="profileEdit" element={<ProfileEdit />} />
        </Route>
      </Routes>
    </>
  );
};

function App() {
  const REACT_APP_GOOGLE_CLIENT_ID = "1092623445209-8h084bf4dilvvaiubhikgh77q130f0es.apps.googleusercontent.com"

  return (
    <Provider store={store}>
      <HashRouter>
        <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>

          <AppContent />
        </GoogleOAuthProvider>

      </HashRouter>
    </Provider>
  );
}

export default App;
